var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSettingsAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 10.296c0-.36-.287-.635-.662-.635-.375 0-.662.275-.662.635 0 2.478-2.095 4.49-4.676 4.49-2.58 0-4.676-2.012-4.676-4.49 0-.36-.287-.635-.662-.635-.375 0-.662.275-.662.635 0 2.944 2.294 5.422 5.338 5.74v1.693H6.934c-.375 0-.662.276-.662.636s.287.635.662.635h6.132c.375 0 .662-.275.662-.635s-.287-.636-.662-.636h-2.404v-1.694C13.706 15.718 16 13.24 16 10.296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1C7.97 1 6.316 2.588 6.316 4.536v5.74c0 1.969 1.655 3.536 3.684 3.557 2.03 0 3.684-1.588 3.684-3.537v-5.76C13.684 2.588 12.029 1 10 1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingsAudio);
export default __webpack_public_path__ + "static/media/icon-settings-audio.feb13952.svg";
export { ForwardRef as ReactComponent };